// Plans & subscription mock data for habita.co

export const PLANS = [
  {
    id: 'gratis',
    name: 'Particular',
    audience: 'propietario',
    price: 0,
    priceLabel: '$0 durante la Beta',
    period: 'mes',
    badge: null,
    color: 'gray',
    description: 'Ideal para vender o arrendar tu primera propiedad.',
    limits: { properties: 1, photos: 5, duration: 30, featured: 0 },
    features: [
      'Hasta 1 publicación activa',
      '5 fotos por inmueble',
      'Publicación por 30 días',
      'Soporte por email',
      'Mensajes ilimitados'
    ],
    notIncluded: [
      'Destacado en búsquedas',
      'Estadísticas avanzadas',
      'Verificación de perfil'
    ],
    cta: 'Empezar gratis'
  },
  {
    id: 'starter',
    name: 'Propietario',
    audience: 'propietario',
    price: 19900,
    priceLabel: '$0 durante la Beta',
    period: 'mes',
    badge: 'Popular',
    color: 'amber',
    description: 'Para propietarios que publican varias propiedades al año.',
    limits: { properties: 3, photos: 15, duration: 60, featured: 1 },
    features: [
      'Hasta 3 publicaciones activas',
      '15 fotos por inmueble',
      'Publicación por 60 días',
      '1 destacado gratis al mes',
      'Estadísticas básicas',
      'Soporte prioritario',
      'Sin marca de agua'
    ],
    notIncluded: [
      'Video tour',
      'Verificación profesional'
    ],
    cta: 'Suscribirme a Starter'
  },
  {
    id: 'pro',
    name: 'Profesional',
    audience: 'agente',
    price: 49900,
    priceLabel: '$0 durante la Beta',
    period: 'mes',
    badge: 'Más elegido',
    color: 'habita',
    description: 'Pensado para agentes inmobiliarios independientes.',
    limits: { properties: 15, photos: 30, duration: 90, featured: 5 },
    features: [
      'Hasta 15 publicaciones activas',
      '30 fotos por inmueble',
      'Publicación por 90 días',
      '5 destacados al mes',
      'Insignia de agente verificado',
      'Perfil profesional público',
      'Estadísticas avanzadas + leads',
      'Video tour por propiedad',
      'Soporte prioritario 24/7'
    ],
    notIncluded: [
      'Multi-agente',
      'API de integración'
    ],
    cta: 'Suscribirme a Pro'
  },
  {
    id: 'inmobiliaria',
    name: 'Inmobiliaria',
    audience: 'inmobiliaria',
    price: 149900,
    priceLabel: '$0 durante la Beta',
    period: 'mes',
    badge: 'Equipos',
    color: 'dark',
    description: 'Para inmobiliarias con equipo de agentes.',
    limits: { properties: 'Ilimitadas', photos: 50, duration: 120, featured: 'Ilimitados' },
    features: [
      'Publicaciones ilimitadas',
      '50 fotos por inmueble',
      'Publicación por 120 días',
      'Destacados ilimitados',
      'Hasta 10 agentes en el equipo',
      'Logo y branding personalizado',
      'CRM básico integrado',
      'API de sincronización',
      'Prioridad en SEO',
      'Gerente de cuenta dedicado',
      'Reportes mensuales',
      'Capacitación para tu equipo'
    ],
    notIncluded: [],
    cta: 'Hablar con ventas'
  },
  {
    id: 'constructora',
    name: 'Constructora',
    audience: 'constructora',
    price: 0,
    priceLabel: '$0 durante la Beta',
    period: 'mes',
    badge: 'Proyectos',
    color: 'habita',
    description: 'Para constructoras que venden sobre planos y proyectos de vivienda nueva.',
    limits: { projects: 'Ilimitados', units_per_project: 'Ilimitadas', properties: 'Ilimitadas', photos: 60, duration: 180, featured: 'Ilimitados' },
    features: [
      'Proyectos ilimitados sobre planos',
      'Tipologías y unidades por proyecto',
      '60 fotos por proyecto',
      'Publicación por 180 días',
      'Integración con el Habita Advisor',
      'Dashboard de inventario multi-tenant',
      'Destacados ilimitados'
    ],
    notIncluded: [],
    cta: 'Hablar con ventas'
  }
];

export const ADDONS = [
  { id: 'destacar', name: 'Destacar publicación', price: 9900, description: 'Aparece en el top de búsquedas por 7 días' },
  { id: 'video', name: 'Video tour', price: 14900, description: 'Añade un video tour profesional a tu publicación' },
  { id: 'home', name: 'Home destacado', price: 24900, description: 'Aparece en la portada de habita.co por 7 días' }
];

// Mock current user with subscription
export const MOCK_USER = {
  id: 'u1',
  name: 'Juan David Pérez',
  email: 'juan.perez@correo.com',
  phone: '+57 310 555 0199',
  avatar: 'https://i.pravatar.cc/150?img=15',
  joinedAt: '2025-03-15',
  currentPlan: 'starter',
  planExpiry: '2025-08-20',
  publishedCount: 2,
  paymentMethod: { brand: 'Visa', last4: '4242', exp: '12/27' }
};

export const MOCK_INVOICES = [
  { id: 'INV-2507-014', date: '2025-07-20', plan: 'Starter', amount: 19900, status: 'pagado', method: 'Visa •••• 4242' },
  { id: 'INV-2506-014', date: '2025-06-20', plan: 'Starter', amount: 19900, status: 'pagado', method: 'Visa •••• 4242' },
  { id: 'INV-2505-014', date: '2025-05-20', plan: 'Starter', amount: 19900, status: 'pagado', method: 'Visa •••• 4242' },
  { id: 'INV-2504-014', date: '2025-04-20', plan: 'Gratis', amount: 0, status: 'pagado', method: '—' }
];

export const MOCK_USER_PROPERTIES = [
  {
    id: 'up1',
    title: 'Apartamento en La Calleja, Bogotá',
    address: 'Calle 127 #19-50, La Calleja',
    city: 'Bogotá',
    price: 580000000,
    operation: 'venta',
    status: 'activa',
    views: 847,
    contacts: 23,
    favorites: 41,
    image: 'https://images.unsplash.com/photo-1484154218962-a197022b5858?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBhcGFydG1lbnR8ZW58MHx8fHwxNzc5NDIwMjU4fDA&ixlib=rb-4.1.0&q=85',
    publishedAt: '2025-07-08',
    expiresAt: '2025-09-08'
  },
  {
    id: 'up2',
    title: 'Casa en Envigado, Antioquia',
    address: 'Calle 38 Sur #28-10',
    city: 'Medellín',
    price: 4200000,
    operation: 'arriendo',
    status: 'activa',
    views: 412,
    contacts: 11,
    favorites: 18,
    image: 'https://images.unsplash.com/photo-1531971589569-0d9370cbe1e5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBob3VzZXxlbnwwfHx8fDE3Nzk0MjAyNTh8MA&ixlib=rb-4.1.0&q=85',
    publishedAt: '2025-07-12',
    expiresAt: '2025-09-12'
  },
  {
    id: 'up3',
    title: 'Apartaestudio en Laureles',
    address: 'Circular 4 #70-15',
    city: 'Medellín',
    price: 320000000,
    operation: 'venta',
    status: 'pausada',
    views: 156,
    contacts: 4,
    favorites: 7,
    image: 'https://images.unsplash.com/photo-1515263487990-61b07816b324?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBhcGFydG1lbnR8ZW58MHx8fHwxNzc5NDIwMjU4fDA&ixlib=rb-4.1.0&q=85',
    publishedAt: '2025-06-15',
    expiresAt: '2025-08-15'
  }
];

export const FAQ_PLANS = [
  { q: '¿Realmente es gratis durante la beta?', a: 'Sí. Mientras dure la beta, todas las funcionalidades premium (Starter, Pro e Inmobiliaria) están disponibles sin costo. No te pedimos tarjeta de crédito, no hay cobros automáticos, no hay sorpresas.' },
  { q: '¿Cuándo empezarán a cobrar?', a: 'Cuando lancemos la versión oficial, te avisaremos con al menos 30 días de anticipación. Tendrás la opción de continuar pagando o volver al plan gratis. Nada cambia sin tu consentimiento explícito.' },
  { q: '¿Pierdo mis datos si decido no pagar luego?', a: 'No. Tus publicaciones, mensajes e historial seguirán siempre disponibles. Si no activas un plan pago, simplemente volverás a los límites del plan Gratis (1 publicación activa).' },
  { q: '¿Puedo cancelar mi acceso beta cuando quiera?', a: 'Sí, en cualquier momento desde tu panel de cuenta. Como no estamos cobrando, "cancelar" simplemente significa volver al plan Gratis.' },
  { q: '¿Qué métodos de pago aceptarán cuando termine la beta?', a: 'Estamos preparando integración con Stripe (tarjetas Visa, Mastercard, AmEx) y PSE. Decidiremos los métodos finales basándonos en feedback de nuestros usuarios beta.' },
  { q: '¿Por qué están dando todo gratis?', a: 'Porque queremos construir habita.co con feedback real de propietarios, agentes e inmobiliarias colombianos. Tu uso durante la beta nos ayuda a entender qué funciona, qué falta y cómo mejorar antes del lanzamiento oficial.' }
];
